import { render, staticRenderFns } from "./CooperationCases.vue?vue&type=template&id=72b840ce&scoped=true"
import script from "./CooperationCases.vue?vue&type=script&lang=js"
export * from "./CooperationCases.vue?vue&type=script&lang=js"
import style0 from "./CooperationCases.vue?vue&type=style&index=0&id=72b840ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b840ce",
  null
  
)

export default component.exports